import React from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { reduxForm, FormSection, FieldArray, formValueSelector, getFormValues, change, Field } from 'redux-form';
import { RaisedButton, Snackbar } from 'material-ui';
import { Toggle, TextField } from 'redux-form-material-ui';
import { compose, lifecycle } from 'recompose';
import _ from 'lodash';
import { getEntities } from 'dash-front/selectors';
import { UI_ACTIONS } from 'dash-front/reducers/ui';
import { STORE_KEYS, CAMPAIGN_FORM_KEYS, MANUAL_POST_FORM_ID } from 'dash-front/constants';
import WidgetForm from 'dash-front/campaign/components/Form/WidgetForm';
import SelectCampaignForm from 'dash-front/campaign/components/Form/SelectCampaignForm';
import WDPWidgetPreview from 'dash-front/campaign/components/Form/WDPWidgetPreview';
import { fetchWidgetSpecs, fetchTemplates } from 'dash-front/actions';
import { manualCreatePost } from 'dash-front/campaign/actions/posts';
import { fetchCampaignsWithPagination } from 'dash-front/campaign/actions/withPagination';
import { withUserData, withCampaigns } from 'dash-front/campaign/enhancers';
import { handleServerError } from 'dash-front/actions/helpers';
import { ParamsCustomizer } from './ParamsCuztomizer';
import { getWidgetParamsInitValue } from './schema';

const mapStateToPropsWidget = state => {
    const widgets = _.get(getEntities(state)[STORE_KEYS.WIDGET_SPECS], 'widgets');
    const templates = getEntities(state)[STORE_KEYS.TEMPLATES];
    return {
        widgets,
        templates
    };
};

const paramsPath = CAMPAIGN_FORM_KEYS.WIDGET.SECTION + '.' + CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.ADDITIONAL.ARRAY;
const updateWidgetParams = value => (dispatch, getState) => {
    const { widget } = value;
    const {
        spec: { propTypes: widgetProps }
    } = widget;
    const initValue = getWidgetParamsInitValue(widgetProps, {});
    return dispatch(change(MANUAL_POST_FORM_ID, paramsPath, initValue));
};

const WidgetFormEnhanced = connect(mapStateToPropsWidget, dispatch => ({
    onChange: value => dispatch(updateWidgetParams(value))
}))(WidgetForm);

const SelectCampaignFormEnhanced = withCampaigns(SelectCampaignForm);
const WDPWidgetPreviewEnhanced = connect(state => {
    var values = getFormValues(MANUAL_POST_FORM_ID)(state);

    const widgets = _.get(getEntities(state)[STORE_KEYS.WIDGET_SPECS], 'widgets');
    const widget = _.find(widgets, w => w.id === _.get(values, 'presentation.name'));
    const isVideo = _.get(widget, 'spec.video', false);

    return values && values.presentation
        ? {
              isVideo,
              name: values.presentation.name,
              params: {
                  client: state.user.client,
                  user: state.user.username,
                  theme: 'social',
                  ...values.presentation.params,
                  ..._.fromPairs(_.get(values, 'presentation.additional', []).map(o => [o.key, o.customValue])),
                  load: isVideo ? 'animated' : undefined
              }
          }
        : {};
})(WDPWidgetPreview);

const selector = formValueSelector(MANUAL_POST_FORM_ID);
const widgetNameKey = CAMPAIGN_FORM_KEYS.WIDGET.SECTION + '.' + CAMPAIGN_FORM_KEYS.WIDGET.NAME;

const mapStateToPropsParams = (state, { fields: { name } }) => {
    const values = selector(state, name);
    const widgetId = selector(state, widgetNameKey);
    const widgets = _.get(getEntities(state)[STORE_KEYS.WIDGET_SPECS], 'widgets');
    return { values, widgets, widgetId };
};

const ParamsCustomizerEnhanced = compose(connect(mapStateToPropsParams))(ParamsCustomizer);

const MessageForm = connect(state => ({
    withMessage: Boolean(formValueSelector(MANUAL_POST_FORM_ID)(state, 'withMessage'))
}))(({ withMessage }) => {
    return (
        <div>
            <div style={{ width: 200 }}>
                <Field name={'withMessage'} component={Toggle} label={'With message'} />
            </div>
            <div>
                {withMessage ? (
                    <FormSection name={'content'}>
                        <Field name={'message'} multiLine floatingLabelText={'Message'} component={TextField} />
                    </FormSection>
                ) : null}
            </div>
        </div>
    );
});

const ManualPost = ({ submit, reset, showBadge }) => {
    return (
        <div>
            <div>
                <div
                    style={{
                        width: 800,
                        margin: '20 auto'
                    }}
                >
                    <WDPWidgetPreviewEnhanced />
                </div>
            </div>

            <SelectCampaignFormEnhanced />

            <FormSection name={CAMPAIGN_FORM_KEYS.WIDGET.SECTION}>
                <WidgetFormEnhanced />

                <FieldArray
                    name={CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.ADDITIONAL.ARRAY}
                    component={ParamsCustomizerEnhanced}
                />
            </FormSection>

            <div style={{ margin: '12px 0px 12px 0px' }}>
                <MessageForm />
            </div>

            <RaisedButton primary label={'Submit'} onTouchTap={submit} />
            <RaisedButton secondary style={{ marginLeft: 12 }} label={'Reset'} onTouchTap={reset} />
            <Snackbar open={showBadge} message="Success" />
        </div>
    );
};

const mapData = values => {
    const { [CAMPAIGN_FORM_KEYS.WIDGET.SECTION]: presentation, withMessage, ...rest } = values;
    const { [CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.ADDITIONAL.ARRAY]: additional, ...restAdditional } = presentation;
    const params = (additional || []).reduce(
        (acc, cur) => {
            acc[cur[CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.ADDITIONAL.KEY]] =
                cur[CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.ADDITIONAL.CUSTOM_VALUE];
            return acc;
        },
        { ...restAdditional[CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.SECTION] }
    );
    return {
        ...rest,
        content: withMessage ? { message: _.get(rest, 'content.message', '') } : {},
        [CAMPAIGN_FORM_KEYS.WIDGET.SECTION]: {
            ...restAdditional,
            [CAMPAIGN_FORM_KEYS.WIDGET.TYPE]: 'widget-social',
            [CAMPAIGN_FORM_KEYS.WIDGET.PARAMS.SECTION]: params
        }
    };
};

const onSubmit = (values, dispatch) => {
    const mappedData = mapData(values);
    return dispatch(manualCreatePost(mappedData)).then(handleServerError);
};

export default compose(
    reduxForm({ form: MANUAL_POST_FORM_ID, onSubmit }),
    withUserData,
    lifecycle({
        componentDidMount() {
            const {
                user: { _id, client },
                dispatch,
                params: { campaignId, widgetId },
                location: { state },
                initialize
            } = this.props;
            const widgetData = {
                presentation: { name: widgetId }
            };
            Promise.all([
                dispatch(fetchWidgetSpecs(client)),
                dispatch(fetchTemplates()),
                dispatch(fetchCampaignsWithPagination(_id))
            ]).then(res => {
                const widgets = _.get(res[0].entities, 'widget-specs.widgets', []);

                if (state) {
                    widgetData.presentation.name = state.widgetId;
                    _.set(widgetData, 'presentation.params.template', state.template);
                    const { props } = state;

                    const additional = Object.keys(props || {}).map(prop => {
                        const normalizedProp = _.camelCase(prop.replace('data-', ''));
                        return {
                            key: prop,
                            value: 'manual',
                            customValue: props[prop],
                            byTrigger: false
                        };
                    });
                    const selectedWidget = widgets.find(el => el.id === state.widgetId);
                    if (selectedWidget) {
                        const { propTypes } = selectedWidget.spec;
                        const filtered = propTypes.filter(
                            prop => prop.key !== 'template' && !additional.some(el => el.key === prop.key)
                        );
                        filtered.forEach(prop => {
                            additional.push({
                                key: prop.key,
                                value: 'manual',
                                customValue: prop.defaultValue,
                                byTrigger: false
                            });
                        });
                    }
                    widgetData.presentation.additional = additional;
                    if (campaignId) {
                        widgetData.campaignId = campaignId;
                    }
                    initialize(widgetData);
                } else {
                    const selectedWidget = widgets.find(w => w.id === widgetId);
                    initialize({ campaignId, ...widgetData });
                }
            });
        },
        componentWillReceiveProps({ submitSucceeded, dispatch }) {
            if (this.props.submitting && submitSucceeded) {
                dispatch({
                    type: UI_ACTIONS.CHANGE,
                    key: 'showBadge',
                    value: true
                });
                setTimeout(
                    () =>
                        dispatch({
                            type: UI_ACTIONS.CHANGE,
                            key: 'showBadge',
                            value: false
                        }),
                    1000
                );
            }
        }
    }),
    connect(state => ({
        showBadge: Boolean(state.ui.showBadge)
    }))
)(ManualPost);



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/containers/Campaign/ManualPost.js
 **/